import React, { Fragment, useState, useRef, useEffect } from 'react';
import { ValidatorForm } from 'react-form-validator-core';
import isEqual from 'lodash/isEqual';
import { Button } from '../../Atoms';
import CompleteSurvey from './CompleteSurvey';
import Questions from './Questions';
import { formatDate, parseDate } from '../../utils/helper';
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

const userFreeTypes = ['text', 'textarea', 'date', 'phone', 'number'];
const multiAnswer = ['checkbox'];

const getAnswer = (question) => {
  const type = question.question_type;
  if (!question.answer) {
    if (multiAnswer.includes(type)) return [];
    return '';
  }
  if (multiAnswer.includes(type)) {
    return question.answer.map((ans) => ans.id.toString());
  } else if (userFreeTypes.includes(type)) {
    if (type === 'date') return parseDate(question.answer[0].answer_text);
    return question.answer[0].answer_text;
  } else {
    return question.answer[0].id;
  }
};

const SurveyCard = ({
  surveyCompleted,
  surveys,
  saveAnswer: { loading, error, success },
  answerQuestion,
  setComplete,
  reset,
}) => {
  const { label, questions } = surveys;
  const index = questions.findIndex((q) => !q.answer);
  const initQuestion = questions[index];
  const initValue = getAnswer(initQuestion);
  const [current, setCurrent] = useState(index);
  const [value, setSelected] = useState(
    !multiAnswer.includes(initQuestion.question_type) ? initValue : ''
  );
  const [multiValue, setMultiValue] = useState(
    multiAnswer.includes(initQuestion.question_type) ? initValue : []
  );

  const setAnswer = (item) => {
    setSelected(item);
  };

  const setMultipleValue = (value) => {
    setMultiValue(value);
  };

  const disabled = !value && !multiValue.length;

  const question = questions[current];

  const prevLoading = usePrevious(loading);

  const stepToNext = () => {
    if (current !== questions.length - 1) {
      const next = current + 1;
      const nextQuestion = questions[next];
      const ans = getAnswer(nextQuestion);
      setCurrent(next);
      setSelected(!multiAnswer.includes(nextQuestion.question_type) ? ans : '');
      setMultipleValue(
        multiAnswer.includes(nextQuestion.question_type) ? ans : []
      );
    } else {
      setComplete();
    }
  };

  useEffect(() => {
    if (prevLoading && !loading && success) {
      stepToNext();
      reset('saveAnswer');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, success]);

  const convertIDtoInt = (ids) => ids.map((id) => parseInt(id));

  const handleNext = () => {
    if (disabled) return;
    const q = questions[current];
    let ans = getAnswer(q);
    let val = value;
    if (q.question_type === 'date') {
      val = formatDate(value);
      ans = formatDate(ans);
    }
    if (
      (!multiAnswer.includes(q.question_type) && ans === val) ||
      (multiAnswer.includes(q.question_type) && isEqual(ans, multiValue))
    ) {
      return stepToNext();
    }

    const payload = {
      question: question.id,
    };

    if (userFreeTypes.includes(question.question_type)) {
      if (question.question_type === 'date') {
        payload.answer = formatDate(value);
      } else {
        payload.answer = value;
      }
    } else {
      if (multiAnswer.includes(question.question_type)) {
        payload.question_answer_options = convertIDtoInt(multiValue);
      } else {
        payload.question_answer_options = convertIDtoInt([value]);
      }
    }
    answerQuestion(payload);
  };

  return (
    <div className="survey-wrapper">
      {!surveyCompleted ? (
        <Fragment>
          <div className="heading-wrapper">
            <h4>{label}</h4>
            <span>
              {current + 1}/{questions.length}
            </span>
          </div>
          <p>{question.text}</p>
          <ValidatorForm onSubmit={handleNext} className="form">
            <Questions
              value={value}
              type={question.question_type}
              setAnswer={setAnswer}
              options={question.answer_options}
              multiValue={multiValue}
              setMultipleValue={setMultipleValue}
              error={error}
            />
            <div className="d-flex justify-content-center align-items-center mt-4">
              <Button
                type="submit"
                size="lg"
                color="blue"
                disabled={disabled}
                loading={loading}
              >
                CONTINUE
              </Button>
            </div>
          </ValidatorForm>
        </Fragment>
      ) : (
        <Fragment>
          <CompleteSurvey />
        </Fragment>
      )}
    </div>
  );
};

export default SurveyCard;
